import { IState } from 'shared/store';
import { IAmenitiesGroup } from 'shared/types/amenities';

export const selectAmenities = (state: IState): IAmenitiesGroup[] | null => {
  return state.offerData.amenities;
};
